export default __webpack_public_path__ + "static/media/Gif_DelftER.8886c153.gif";